import { render, staticRenderFns } from "./ItemCreateModal.vue?vue&type=template&id=27cc36c2&"
import script from "./ItemCreateModal.vue?vue&type=script&lang=js&"
export * from "./ItemCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports